import React from 'react';
import { EditDashboard } from './EditDashboard';

export const DashboardExampleDetails = () => (
    <EditDashboard exampleMode />
);
